/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./i18n";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  tracesSampleRate: 1.0,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Apply the persisted theme before first render. The dark theme is the
// default (:root in index.css); a saved "light" preference opts into the
// `.light` class. Without this the Profile dark-mode toggle reset to dark
// on every cold start.
try {
  if (localStorage.getItem("theme") === "light") {
    document.documentElement.classList.add("light");
  }
} catch {
  /* localStorage may be unavailable in sandboxed webviews */
}

createRoot(document.getElementById("root")!).render(<App />);
